<!--table 编辑 -->
<template>
  <div class="custom_table_template2">
    <el-radio-group v-model="checkedStatus" @change="tabchange">
      <el-radio-button
        v-for="state in states"
        :label="state.label"
        :key="state.text"
        >{{ state.text }}</el-radio-button
      >
    </el-radio-group>
    <diagnosis v-if="checkedStatus=='diagnosis'" :ddid='ddid'></diagnosis>
    <Prescribing v-else-if="checkedStatus=='Prescribing'" :ddid='ddid'></Prescribing>
  </div>
</template>
<script>
// import axiosUtil from "../../utils/AxiosUtils.js";
import diagnosis from "../../components/recipel/diagnosis.vue"
import Prescribing from "../../components/recipel/Prescribing.vue"
export default {
  data() {
    return {
      checkedStatus: "diagnosis",
      ddid:this.$route.query.ddid,
      states: [
        {
          label: "diagnosis",
          text: "诊断",
        },
        {
          label: "Prescribing",
          text: "开处方",
        },
      ],
    };
  },
  components: {
    diagnosis,
    Prescribing
  },
  mounted() {
  },
  methods: {
    tabchange() {},
  },
};
</script>
<style lang="scss">
.custom_table_template2 {
  width: 100%;
  height: 100%;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
